// extracted by mini-css-extract-plugin
module.exports = {"v-icon":"NsAddressUa_v-icon_3nfm7","nsAddressForm":"NsAddressUa_nsAddressForm_2UJwx","dualColumn":"NsAddressUa_dualColumn_1TgPU","firstCol":"NsAddressUa_firstCol_2nxRO"};